import { gql } from '@apollo/client';

export * from './repoUploadCancel.mutation.generated';

export const REPO_UPLOAD_CANCEL = gql`
  mutation repoUploadCancel($softwareEscrowId: ID!, $uploadId: String!, $assetId: ID) {
    repoUploadCancel(input: { softwareEscrowId: $softwareEscrowId, uploadId: $uploadId, assetId: $assetId }) {
      success
      errors
    }
  }
`;
